// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"1fdfd416","281":"6b4bdcc0","513":"1cd4ff92","768":"4d076dba","991":"47d8286a"}[chunkId] + ".chunk.js";
};